<!--
 * @Description: 国际运输
 * @Author: zml
 * @Date: 2023-12-18 09:32:19
 * @LastEditors: zml
 * @LastEditTime: 2023-12-18 09:37:02
-->
<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'international',
  mixins: [mixins],

  data() {
    return {
      componentName: ''
    }
  },
  created() {
    this.initDom()
  },
  methods: {
    initDom() {
      switch (this.$templates()) {
        case 'themeTemplateSeven':
          this.componentName = 'pageInternationalSeven'
          break
        default:
          this.componentName = ''
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>